<script>
import VueCharts from 'vue-chartjs'
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'centerText', 'pie'],
  mounted () {
    if(!this.pie) {
      Chart.pluginService.register({
        beforeDraw: function (chart) {
          if (chart.config.options.elements.center) {
            var ctx = chart.chart.ctx;

            var centerConfig = chart.config.options.elements.center;
            var fontStyle = centerConfig.fontStyle || '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"';

            var txt = centerConfig.text;
            var color = centerConfig.color || '#000';
            var sidePadding = centerConfig.sidePadding || 20;
            var sidePaddingCalculated = (sidePadding/100) * (chart.innerRadius * 2)

            ctx.font = "30px " + fontStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
            var elementHeight = (chart.innerRadius * 2);

            var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
            var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

            ctx.clearRect(centerX-elementWidth/2, centerY-elementHeight/2, elementWidth, elementHeight);

            if (txt[1] !== undefined) {
              var stringWidth = ctx.measureText(txt[1]).width;
              var widthRatio = elementWidth / stringWidth;
              var newFontSize = Math.floor(30 * widthRatio);
              if (widthRatio > 0.86) {
              var newFontSize = Math.floor(15 * widthRatio);
              }
              var smallSizeToUse = Math.min(newFontSize, elementHeight);
              ctx.font = smallSizeToUse+"px " + fontStyle;
              ctx.fillText(txt[1], centerX, centerY+smallSizeToUse);

              var stringWidth = ctx.measureText(txt[0]).width;
              var widthRatio = elementWidth / stringWidth;
              var newFontSize = Math.floor(30 * widthRatio);
              var bigSizeToUse = Math.min(newFontSize, elementHeight*0.5);
              ctx.font = bigSizeToUse+"px " + fontStyle;
              ctx.fillText(txt[0], centerX, centerY-smallSizeToUse);
            } else {
              var stringWidth = ctx.measureText(txt[0]).width;
              var widthRatio = elementWidth / stringWidth;
              var newFontSize = Math.floor(30 * widthRatio);
              var fontSizeToUse = Math.min(newFontSize, elementHeight);
              ctx.font = fontSizeToUse+"px " + fontStyle;
              ctx.fillStyle = color;
              ctx.fillText(txt, centerX, centerY);
            }

          }
        }
      });
    }
    this.renderMyChart();
  },
  computed: {
    chartData: function() {
      return this.data;
    },
  },
  methods: {
    updateMyChart: function () {
      for(var i = 0; i < this.$data._chart.data.datasets.length; i++){
        this.$data._chart.data.datasets[i].data = this.chartData[i].data;
      }
      this.$data._chart.options.elements.center.text = this.centerText;
      this.$data._chart.update();
    },
    renderMyChart: function () {
      this.renderChart({
        datasets: this.chartData,
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: this.pie ? 0 : 50,
        elements: {
          center: {
            text: this.centerText,
          },
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var index = tooltipItem.index;
              return dataset.labels[index] + ': ' + dataset.data[index];
            }
          }
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            event.stopPropagation();
            this.$emit('segment-click', elements[0]._index);
          }
        },
        onHover: (event, elements) => {
          event.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
        },
      });
    }
  },
  watch: {
    data: function() {
      this.updateMyChart();
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/DonutChart.vue